import Link from "react-scroll/modules/components/Link";
import React from "react";
import Hamburger from  'hamburger-react';
import "./Navbar.css";
import pdfs from '../../fp06_006-Shiv_Pratap_Singh_Yadav_Resume.pdf'
let pdf="https://drive.google.com/uc?export=download&id=1FDi6FTc3jF13LVBwpJlRNpdCgthyZ53k"
export default function Navbar() {
  return (
    <div className="navbar">
      <div className="logo">
        <h1 className="logo-h1" style={{fontFamily:"cursive"}}>Shiv.Pr</h1>
      </div>
      <input id="checkbox" type="checkbox" />
      <div id="bar">
        <label htmlFor="checkbox">
        
      <Hamburger className="Hamburger"/>
        </label>
      </div>
      <ul className="nav-ul">
        <Link to="home" smooth={true} duration={500}>
          <li>Home</li>
        </Link>
        <Link to="about" smooth={true} duration={500}>
          <li>About</li>
        </Link>
        <Link to="skill" smooth={true} duration={500}>
          <li>Skills</li>
        </Link>
        <Link to="project" smooth={true} duration={500}>
          <li>Projects</li>
        </Link>
        <Link to="contact" smooth={true} duration={500}>
          <li>Contact</li>
        </Link>
        <a
          href={pdf}
          target="_blank"
          rel="noreferrer"
          download
        >
          <li>Resume</li> 
          
        </a>
      </ul>
      
    </div>
    
  );
}